import { ENTITIES, ACTIONS, PERMISSIONS } from './constants';

/*
interface Rule {
  actions: string | string[],
  subject: string | string[],
  conditions?: Object,
  fields?: string[],
  inverted?: boolean, // default is `false`
  reason?: string // mainly to specify why user can't do something. See forbidden reasons for details
}
*/

export const PERMISSION_RULES_MAP = {
  [PERMISSIONS.SERIES_MANAGEMENT]: [
    {
      subject: ENTITIES.PROGRAM,
      actions: [ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.CREATE, ACTIONS.INVITE],
    },
    {
      subject: ENTITIES.MODULES,
      actions: [
        ACTIONS.INVITE,
        ACTIONS.ARCHIVE,
        ACTIONS.DELETE,
        ACTIONS.COPY,
        ACTIONS.MOVE,
        ACTIONS.PUBLISH,
      ],
    },
  ],
  [PERMISSIONS.PERMISSIONS_MANAGEMENT]: [
    {
      subject: ENTITIES.PERMISSIONS,
      actions: [ACTIONS.UPDATE],
    },
  ],
  [PERMISSIONS.MODULE_DEVELOPMENT]: [
    {
      subject: ENTITIES.MODULES,
      actions: [ACTIONS.COPY, ACTIONS.MOVE, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.CREATE],
    },
  ],
  [PERMISSIONS.LEARNER_MANAGEMENT]: [
    {
      subject: ENTITIES.LEARNERS,
      actions: [
        ACTIONS.READ,
        ACTIONS.UPDATE,
        ACTIONS.DELETE,
        ACTIONS.CREATE,
        ACTIONS.INVITE,
        ACTIONS.VIEW_ANALYTICS,
      ],
    },
  ],
  [PERMISSIONS.SCOPED_LEARNER_MANAGEMENT_EDIT]: [
    {
      subject: ENTITIES.LEARNERS,
      actions: [ACTIONS.READ, ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.CREATE, ACTIONS.INVITE],
    },
  ],
  [PERMISSIONS.SCOPED_LEARNER_MANAGEMENT_VIEW]: [
    {
      subject: ENTITIES.LEARNERS,
      actions: [ACTIONS.READ, ACTIONS.INVITE],
    },
  ],
  [PERMISSIONS.MODULE_SHARING]: [
    {
      subject: ENTITIES.MODULES,
      actions: [ACTIONS.INVITE, ACTIONS.PUBLISH],
    },
    {
      subject: ENTITIES.PROGRAM,
      actions: [ACTIONS.INVITE],
    },
  ],
  [PERMISSIONS.SERIES_VIEW_ANALYTICS]: [
    {
      subject: ENTITIES.PROGRAM,
      actions: [ACTIONS.VIEW_ANALYTICS],
    },
  ],
  [PERMISSIONS.MODULE_VIEW_ANALYTICS]: [
    {
      subject: ENTITIES.MODULES,
      actions: [ACTIONS.VIEW_ANALYTICS],
    },
  ],
  [PERMISSIONS.CATEGORY_MANAGEMENT]: [
    {
      subject: ENTITIES.CATEGORY,
      actions: [ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.CREATE],
    },
  ],
  [PERMISSIONS.GROUP_ADMINISTRATION]: [
    {
      subject: ENTITIES.GROUPS,
      actions: [ACTIONS.UPDATE, ACTIONS.INVITE, ACTIONS.DELETE, ACTIONS.READ],
    },
    {
      subject: ENTITIES.LEARNERS,
      actions: [ACTIONS.INVITE_EXISTING, ACTIONS.UPDATE_RELATION],
    },
  ],
  [PERMISSIONS.CONTENT_SHARING_VIA_GROUP]: [
    {
      subject: ENTITIES.GROUPS,
      actions: [ACTIONS.UPDATE, ACTIONS.INVITE, ACTIONS.READ],
    },
  ],
  [PERMISSIONS.GROUP_VIEW_ANALYTICS]: [
    {
      subject: ENTITIES.GROUPS,
      actions: [ACTIONS.VIEW_ANALYTICS],
    },
  ],
  [PERMISSIONS.MANAGE_ACCREDITATIONS]: [
    {
      subject: ENTITIES.ACCREDITATION,
      actions: [ACTIONS.UPDATE, ACTIONS.DELETE, ACTIONS.CREATE, ACTIONS.INVITE, ACTIONS.READ],
    },
  ],
  [PERMISSIONS.VIEW_COMPETENCY_REPORT]: [
    {
      subject: ENTITIES.MODULES,
      actions: [ACTIONS.VIEW_COMPETENCY_ANALYTICS],
    },
  ],
};
